import {MI} from "../init";
import MadnesTween from "../libs/mi/MadnesTween";

/**
 * @constructor
 * @param {Game} game
 * @returns {WinViewer}
 */
export default function WinViewer(game) {

    /** @type {Game} */
    this._game = game;

    /** @type {Object<string,MadnesAudio>} */
    this._sounds = game.sounds;

    /** @type {MadnesObject} */
    this._text;

    //this._win = 0;

    /** @type {MadnesGroup} */
//	this._dustGroup;

    /** @type {MadnesTween} */
    //this._tweenScale;
}

/**
 * @param {number} win
 */
WinViewer.prototype.create = function(win) {

    this._text = MI.addImg(MI.getWi() / 2, MI.getHe() / 2, "win_font_bg");
    this._text.setAnchor(0.5, 0.5);
    this._text.setAlpha(0);
    this._text.setScale(1.4, 1.4);
    this._text.setVisible(false);

    this._text.addChild(MI.addBitmapText("font_big_win", 0, 0, win, 80).setAnchor(0.5, 0.5));
};

WinViewer.prototype.run = function() {
    var _self = this;

    return new Promise(function(res) {

        MI.createTimer().add(function() {
            _self._sounds["ui_Counter_Stop"].play();
        }, 150);

        MI.addTween().to(_self._text, { 'x': 1, 'y': 1, 'alpha': 1 }, {
            'scale': true,
            'duration': 300,
            'easing': MadnesTween.getEasing('quad_in'),
            'onStart': function() {
                _self._text.setVisible(true);
            },
            'callback': function() {

                MI.addTween().to(_self._text, { 'alpha': 0 }, {
                    'delay': 300,
                    'duration': 200,
                    'callback': function() {
                        _self._text.destroy();
                        res();
                    }
                });
            }
        });

        MI.addTween().to(_self._text, { 'alpha': 1 }, {
            'duration': 300
        });
    });
};